import { css } from '@emotion/react';

export const formattingGroupSpacing = css`
  margin-bottom: 20px;
`;
